import { Link, NavLink, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { MapPin, Phone, Mail, Globe, Menu, X } from 'lucide-react';

const ZAN_LOGO_URL = '/zan-logo.png';

const SOCIAL_LINKS = [
  { name: 'Facebook', url: 'https://www.facebook.com/share/1C4rgY4HuU/?mibextid=wwXIfr', icon: '/icons/social/facebook.png' },
  { name: 'Instagram', url: 'https://www.instagram.com/zimaidsnetwork?igsh=MXVxdTRpbmFsaTIyNA==', icon: '/icons/social/instagram.png' },
  { name: 'WhatsApp', url: 'https://whatsapp.com/channel/0029VakQl4a7j6g4G10ykh2w', icon: '/icons/social/whatsapp.png' },
  { name: 'Twitter / X', url: 'https://x.com/zimaidsnet?s=11', icon: '/icons/social/twitter.png' },
  { name: 'Website', url: 'https://www.zimaidsnetwork.org', icon: '/icons/social/website.png' },
];

function PublicNavbar() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const links = [
    { to: '/', label: 'Home', end: true },
    { to: '/about', label: 'About Us' },
    { to: '/csos', label: 'CSOs' },
    { to: '/provinces', label: 'Provinces' },
    { to: '/resources', label: 'Resources' },
    { to: '/news', label: 'News' },
    { to: '/contact', label: 'Contact Us' },
  ];

  return (
    <nav className="pub-nav">
      <div className="pub-nav-inner">
        <Link to="/" className="pub-nav-logo">
          <img
            src={ZAN_LOGO_URL}
            alt="ZAN Logo"
            style={{ width: 42, height: 42, borderRadius: 6, objectFit: 'contain' }}
          />
          <div>
            <div className="pub-nav-logo-title">ZIM CSO DATABASE</div>
            <div className="pub-nav-logo-sub">Empowering Communities. Building A Healthier Zimbabwe.</div>
          </div>
        </Link>

        <button
          className="pub-nav-toggle"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          {menuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>

        <div className={`pub-nav-links${menuOpen ? ' open' : ''}`}>
          {links.map(l => (
            <NavLink key={l.to} to={l.to} end={l.end}
              onClick={() => setMenuOpen(false)}
              className={({ isActive }) => `pub-nav-link${isActive ? ' active' : ''}`}>
              {l.label}
            </NavLink>
          ))}
        </div>

        <div className="pub-nav-actions">
          {user ? (
            <Link to="/admin" className="btn btn-primary btn-sm">Admin Panel →</Link>
          ) : (
            <Link to="/admin/login" className="btn btn-primary btn-sm">Staff Login</Link>
          )}
          <button onClick={() => navigate('/csos')} className="btn btn-dark btn-sm">Search Organisations</button>
        </div>
      </div>
    </nav>
  );
}

function PublicFooter() {
  return (
    <footer className="pub-footer">
      <div className="page-container">
        <div className="pub-footer-grid" style={{ display:'grid', gridTemplateColumns:'2fr 1fr 1fr 1fr', gap:40, paddingBottom:40 }}>
          <div>
            <div style={{ display:'flex', alignItems:'center', gap:12, marginBottom:16 }}>
              <img
                src={ZAN_LOGO_URL}
                alt="ZAN Logo"
                style={{ width: 40, height: 40, borderRadius: 8, objectFit: 'contain', background: 'rgba(255,255,255,0.1)' }}
              />
              <div>
                <div style={{ color:'white', fontWeight:700, fontSize:'0.9rem' }}>ZIM CSO DATABASE</div>
                <div style={{ color:'rgba(255,255,255,0.4)', fontSize:'0.68rem' }}>Empowering Communities. Building a healthier Zimbabwe.</div>
              </div>
            </div>
            <p style={{ fontSize:'0.82rem', lineHeight:1.7, marginBottom:16 }}>
              This Database of Civil Society Organizations in Zimbabwe's health sector is
              managed by the Zimbabwe AIDS Network (ZAN).
            </p>
            <div style={{ display:'flex', gap:6, flexWrap:'wrap' }}>
              {['Global Fund','UNDP','Zimbabwe AIDS Network'].map(p => (
                <span key={p} style={{ padding:'2px 9px', borderRadius:20, background:'rgba(255,215,0,0.1)', border:'1px solid rgba(255,215,0,0.2)', color:'rgba(255,255,255,0.7)', fontSize:'0.7rem' }}>{p}</span>
              ))}
            </div>
          </div>
          <div>
            <h4>Quick Links</h4>
            {[['/',          'Home'],
              ['/about',     'About Us'],
              ['/csos',      'CSO Directory'],
              ['/provinces', 'Provinces'],
              ['/resources', 'Resources'],
              ['/news',      'News'],
              ['/contact',   'Contact Us'],
            ].map(([to,label]) => <Link key={to} to={to}>{label}</Link>)}
          </div>
          <div>
            <h4>Provinces</h4>
            {['Harare','Bulawayo','Manicaland','Masvingo','Midlands','Mash. Central','Mash. East','Mash. West','Mat. North','Mat. South']
              .map(p => <a key={p} href={`/provinces`}>{p}</a>)}
          </div>
          <div>
            <h4>Contact ZAN</h4>
            <div style={{ fontSize:'0.82rem', lineHeight:2.2 }}>
              <div style={{ display:'flex', alignItems:'center', gap:6 }}>
                <MapPin size={14} /> 30 St Patricks Road, Hatfield, Harare
              </div>
              <div style={{ display:'flex', alignItems:'center', gap:6 }}>
                <Phone size={14} /> +263242570604 / +263773451238
              </div>
              <div style={{ display:'flex', alignItems:'center', gap:6 }}>
                <Mail size={14} /> zimaidsnetworkdirector@gmail.com
              </div>
              <div style={{ display:'flex', alignItems:'center', gap:6 }}>
                <Globe size={14} /> zimaidsnetwork.org
              </div>
            </div>
            <div style={{ marginTop:16, display:'flex', gap:10, alignItems:'center' }}>
              {SOCIAL_LINKS.map((social) => (
                
                <a
                  key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  title={social.name}
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 32,
                    height: 32,
                    borderRadius: 6,
                    background: 'rgba(255,255,255,0.08)',
                    transition: 'transform 0.2s, background 0.2s',
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.transform = 'scale(1.1)';
                    e.currentTarget.style.background = 'rgba(255,255,255,0.15)';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.transform = 'scale(1)';
                    e.currentTarget.style.background = 'rgba(255,255,255,0.08)';
                  }}
                >
                  <img
                    src={social.icon}
                    alt={social.name}
                    style={{ width: 20, height: 20, objectFit: 'contain' }}
                  />
                </a>
              ))}
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <span>© {new Date().getFullYear()} Zimbabwe AIDS Network (ZAN). All rights reserved.</span>
          <span>Funded by <span style={{ color:'var(--gold)' }}>Global Fund</span> | Supported by <span style={{ color:'var(--gold)' }}>UNDP</span></span>
        </div>
      </div>
    </footer>
  );
}

export default function PublicLayout({ children }) {
  return (
    <div>
      <PublicNavbar/>
      <main>{children}</main>
      <PublicFooter/>
    </div>
  );
}
